import React from 'react';
import { Layout } from 'tea-component';
import '@/pages/opinion/assets/scss/pages/dataMap/opinionsMetrics.scss';
import Data from '../components/data';
import metrics from '../constants/metrics';
import { getLocale, useIntl } from 'umi';
import OpinionsMetricsPoint from '@op/operationLog/pages/opinionsMetrics';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { keywordRenderFunc } from '@/pages/opinion/utils/text';
const { Body, Content } = Layout;

const OpinionsMetrics = () => {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  useInitBuriedPointInfo({ buriedPoint: OpinionsMetricsPoint });
  return (
    <Layout className="dbo-opinions-metrics">
      <Body>
        <Content>
          <ContentBody
            contentHeard={
              <Content.Header
                className="contentHead-normal"
                title={formatMessage({ id: 'Opinions Metrics' })}
              >
                <div className="metrics-title">
                  {formatMessage({
                    id: 'In this section you can learn details about each metric in Opinions module.',
                  })}
                </div>
              </Content.Header>
            }
          >
            <Data
              className="dbo-datamap-metrics-table dbo-table-sticky"
              justifyClassName="metrics-justify"
              searchClassName="metrics-search"
              records={metrics}
              placeholder="Search by metrics"
              recordKey="metrics_en"
              columns={(pageIndex: number, pageSize: number, search = '') => [
                {
                  key: 'rank',
                  header: '#',
                  width: 60,
                  render: (record: any, text: any, index: number) =>
                    (pageIndex - 1) * pageSize + index + 1,
                },
                {
                  key: 'metrics',
                  header: formatMessage({ id: 'Metrics' }),
                  width: 200,
                  render: (record: any) => {
                    let text =
                      locale === 'en-US'
                        ? record.metrics_en
                        : record.metrics_cn;

                    return keywordRenderFunc({
                      text,
                      keyword: search,
                    });
                  },
                },
                {
                  key: 'description',
                  header: formatMessage({ id: 'Description' }),
                  width: 880,
                  render: (record: any) => {
                    const content =
                      locale === 'en-US' ? record.desc_en : record.desc_cn;
                    return (
                      <div style={{ whiteSpace: 'pre-wrap' }}>
                        {keywordRenderFunc({
                          text: content,
                          keyword: search,
                        })}
                      </div>
                    );
                  },
                },
                {
                  key: 'data',
                  header: formatMessage({ id: 'Data Granularity' }),
                  width: 200,
                  render: (record: any) => {
                    return locale === 'en-US'
                      ? record.granularity_en
                      : record.granularity_cn;
                  },
                },
              ]}
            />
          </ContentBody>
        </Content>
      </Body>
    </Layout>
  );
};

export default OpinionsMetrics;
